import cookies from 'js-cookie'

export enum CookieName {
  UniversalLoginFlow = 'universal-login-flow',
  AnalyticsGACID = '_sg_analytics_ga_cid',
  AnalyticsGASID = '_sg_analytics_ga_sid',
  AnalyticsCountry = '_sg_analytics_country',
}

export const Cookies = cookies.withAttributes({
  secure: ['test', 'production'].includes(import.meta.env.MODE),
  sameSite: 'strict',
  path: '/',
})
